import { render, staticRenderFns } from "./InventoryTable.vue?vue&type=template&id=5a9109f4"
import script from "./InventoryTable.vue?vue&type=script&lang=ts"
export * from "./InventoryTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports